import styled from 'styled-components';
import { breakpoints } from 'styles/breakpoints';

export const StyledBundlePriceButton = styled.div.attrs({
  className: 'bundlePriceButton',
})`
  width: 100%;
  padding-bottom: 5px;
  border-radius: 4px;
  background: var(--button-bg-color);
  box-shadow: 0px 2px 4px 0px #130d3a;
` as any;

export const StyledBundlePrice = styled.div`
  font-family: var(--font-family);
  background: var(--button-bg-color);
  height: 27px;
  width: 100%;
  border-radius: 6px;
  box-shadow: 0px -1px 4.3px 0px #14fd29 inset;

  display: flex;
  direction: ltr;
  justify-content: center;
  align-items: center;
  color: var(--button-text-color);
  position: relative;

  .totalPrice {
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 10;
    white-space: nowrap;
    font-weight: 700;

    @media (width < ${breakpoints.mobileS}) {
      font-size: 12px;
    }
  }
` as any;
